import { useContext } from 'react';
import { LocalizationContext } from '../../context/localizationContext';
import { DataProtectionPolicyPage } from './DataProtectionPolicyPage';

export const DataProtectionPolicyUsPage = ({ page = 'portal.data.protectionPolicy' }) => {
  const localizationContext = useContext(LocalizationContext);
  return <DataProtectionPolicyPage page={page} langCode={localizationContext.locale} />;
};
